import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { StorageService } from './Services/storage.service';
import { Constants } from '../constants';
import { environment } from '../environments/environment';

export function appInitializerFactory(translate: TranslateService, storage: StorageService, injector: Injector) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const requestedLang = storage.getLanguage();
      const langToSet = environment.locales.includes(requestedLang) ? requestedLang : environment.defaultLocale;
      if (langToSet !== requestedLang) {
        storage.setLanguage(langToSet);
      }
      translate.setDefaultLang(Constants.defaultLang);
      translate.use(langToSet).subscribe(() => {
        console.info(`Successfully initialized '${langToSet}' language.'`);
      }, () => {
        console.error(`Problem with '${langToSet}' language initialization.'`);
      }, () => {
        resolve(null);
      });
    });
  });
}